
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.852 6.069a3.745 3.745 0 115.296 5.296 3.745 3.745 0 01-5.296-5.296zm2.648.449a2.2 2.2 0 100 4.398 2.2 2.2 0 000-4.398z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.5 2a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm5.18 13.14a6.954 6.954 0 10-10.36 0 6.716 6.716 0 0110.36 0zm-9.206 1.03a6.955 6.955 0 008.052 0 5.17 5.17 0 00-8.052 0z","fill":"currentColor"}})])
          )
        }
      }
    